<template>
    <div class="actions-menu">
        <ui5-button class="dummy" ref="dummy">
            <!-- For positioning the popover (margin-top won't work) -->
            <div>
                <span>Acties</span>
                <i class="fa fa-1x fa-caret-up" />
            </div>
        </ui5-button>
        <ui5-button @click="openMenu" ref="actionsMenuButton">
            <div>
                <span>Acties</span>
                <i
                    class="fa fa-1x"
                    :class="{ 'fa-caret-up': open, 'fa-caret-down': !open }" />
            </div>
        </ui5-button>
        <ui5-popover
            ref="actionsMenuPopover"
            no-arrow="true"
            placement-type="Bottom"
            horizontal-align="Right">
            <slot />
        </ui5-popover>
    </div>
</template>
<script>
export default {
    data() {
        return {
            open: false,
        };
    },
    mounted() {
        this.$refs.actionsMenuPopover.addEventListener('after-close', () => {
            this.open = false;
        });

        //Close menu when an item is clicked (regardless of item implementation)
        this.$nextTick(() => {
            this.$el.querySelectorAll('ui5-popover > *').forEach((element) => {
                element.addEventListener('click', () => {
                    if (this.$refs.actionsMenuPopover) {
                        // Is undefined if navigation is faster
                        this.$refs.actionsMenuPopover.close();
                    }
                });
            });
        });
    },
    updated() {
        //Dynamically insert HR between the items
        this.$el.querySelectorAll('ui5-popover > hr').forEach((hr) => {
            hr.remove();
        });
        Array.from(this.$el.querySelectorAll('ui5-popover > *')).forEach(
            (element) => {
                if (
                    element.nodeType == Node.ELEMENT_NODE &&
                    element.nextElementSibling
                ) {
                    element.insertAdjacentHTML('afterend', '<hr>');
                }
            }
        );
    },
    methods: {
        openMenu() {
            this.$refs.actionsMenuPopover.showAt(this.$refs.dummy);
            this.open = true;
        },
    },
};
</script>
